/**
 * A list of common polyfills for our apps
 *
 * If there get to be too many, then we can shift to using a package
 * https://stackoverflow.com/a/43756218/4717829
 */
const polyfills = () => {
    // Array.flat()
    if (!Array.prototype.flat) {
        // eslint-disable-next-line no-extend-native
        Object.defineProperty(Array.prototype, 'flat', {
            value: function (depth = 1, stack = []) {
                for (const item of this) {
                    if (item instanceof Array && depth > 0) {
                        // @ts-expect-error: FIXME types
                        item.flat(depth - 1, stack);
                    }
                    else {
                        // @ts-expect-error: FIXME types
                        stack.push(item);
                    }
                }
                return stack;
            },
        });
    }
};
export default polyfills;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9seWZpbGxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3V0aWwvcG9seWZpbGxzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7R0FLRztBQUVILE1BQU0sU0FBUyxHQUFHLEdBQUcsRUFBRTtJQUNyQixlQUFlO0lBQ2YsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxFQUFFO1FBQ3pCLDRDQUE0QztRQUM1QyxNQUFNLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxTQUFTLEVBQUUsTUFBTSxFQUFFO1lBQzdDLEtBQUssRUFBRSxVQUFVLEtBQUssR0FBRyxDQUFDLEVBQUUsS0FBSyxHQUFHLEVBQUU7Z0JBQ3BDLEtBQUssTUFBTSxJQUFJLElBQUksSUFBSSxFQUFFO29CQUN2QixJQUFJLElBQUksWUFBWSxLQUFLLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRTt3QkFDdEMsZ0NBQWdDO3dCQUNoQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssR0FBRyxDQUFDLEVBQUUsS0FBSyxDQUFDLENBQUM7cUJBQzdCO3lCQUFNO3dCQUNMLGdDQUFnQzt3QkFDaEMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztxQkFDbEI7aUJBQ0Y7Z0JBRUQsT0FBTyxLQUFLLENBQUM7WUFDZixDQUFDO1NBQ0YsQ0FBQyxDQUFDO0tBQ0o7QUFDSCxDQUFDLENBQUM7QUFFRixlQUFlLFNBQVMsQ0FBQyJ9